import { AppCookies } from '@enums/cookies';
import useWelcomeVoucherQuery from '@hooks/user/use-welcome-voucher-query';
import { useState } from 'react';
import Cookies from 'universal-cookie';
import Environment from '@config/environment';

const usePdpWelcomeVoucherQuery = () => {
  const [bannerClosed, setBannerClosed] = useState<boolean>(false);

  const onCloseBanner = () => {
    setBannerClosed(true);
    const cookies = new Cookies();
    cookies.set(AppCookies.PDP_WELCOME_OFFER_CLOSED, true, {
      path: '/',
      domain: Environment.cookieOptions.domain,
      expires: new Date(Date.now() + 10 * 60 * 1000),
    });
  };
  const { welcomeVoucher } = useWelcomeVoucherQuery({ touchPoint: 'PDP' });

  return {
    showWelcomeBanner: !bannerClosed,
    bannerText: welcomeVoucher?.text,
    voucherCode: welcomeVoucher?.voucherCode,
    onClose: onCloseBanner,
    setBannerClosed,
  };
};

export default usePdpWelcomeVoucherQuery;
